import Entity from '../entity'

export default class Coupon extends Entity<number>{
 name:string="";
 amount:number=0;
 isActivity:boolean=false;
 isNewCoupon:boolean=false;
 startTime:Date;
 endTime:Date;
 remark:string="";
}
